export enum MarketplaceOpportunityStatus {
    NewOpportunity,
    Engaged,
    RejectedByBuyer,
    RejectedBySeller,
    LostOpportunity,
    Tagged,
    BuyerMissedDeadline,
    AwaitingBuyerResponse,
    AwaitingSellerResponse,
    Suspended,
    Terminated,
}

export const MarketplaceOpportunityStatusList = [
    {
        id: MarketplaceOpportunityStatus.NewOpportunity,
        name: 'New Opp',
        color: '#535bd6',
    },
    {
        id: MarketplaceOpportunityStatus.Engaged,
        name: 'Engaged',
        color: '#008000',
    },
    {
        id: MarketplaceOpportunityStatus.RejectedByBuyer,
        name: 'Rejected by Buyer',
        color: '#ff6347',
    },
    {
        id: MarketplaceOpportunityStatus.RejectedBySeller,
        name: 'Rejected by Seller',
        color: '#ff6347',
    },
    {
        id: MarketplaceOpportunityStatus.LostOpportunity,
        name: 'Lost Opp',
        color: '#808080',
    },
    {
        id: MarketplaceOpportunityStatus.Tagged,
        name: 'Tagged',
        color: '#8a2be2',
    },
    {
        id: MarketplaceOpportunityStatus.BuyerMissedDeadline,
        name: 'Buyer Missed Deadline',
        color: '#ff4500',
    },
    {
        id: MarketplaceOpportunityStatus.AwaitingBuyerResponse,
        name: 'Awaiting Buyer Response',
        color: '#deb24d',
    },
    {
        id: MarketplaceOpportunityStatus.AwaitingSellerResponse,
        name: 'Awaiting Seller Response',
        color: '#008000',
    },
    {
        id: MarketplaceOpportunityStatus.Suspended,
        name: 'Suspended by Seller',
        color: '#ff4500',
    },
    {
        id: MarketplaceOpportunityStatus.Terminated,
        name: 'Terminated by Seller',
        color: '#ff4500',
    },
];

export const MarketplaceOpportunityStatusOptions = {
    [MarketplaceOpportunityStatus.NewOpportunity]: 'New Opp',
    [MarketplaceOpportunityStatus.Engaged]: 'Engaged',
    [MarketplaceOpportunityStatus.RejectedByBuyer]: 'Rejected by Buyer',
    [MarketplaceOpportunityStatus.RejectedBySeller]: 'Rejected by Seller',
    [MarketplaceOpportunityStatus.LostOpportunity]: 'Lost Opp',
    [MarketplaceOpportunityStatus.Tagged]: 'Tagged',
    [MarketplaceOpportunityStatus.BuyerMissedDeadline]: 'Buyer Missed Deadline',
    [MarketplaceOpportunityStatus.AwaitingBuyerResponse]:
        'Awaiting Buyer Response',
    [MarketplaceOpportunityStatus.AwaitingSellerResponse]:
        'Awaiting Seller Response',
};
